import { createMuiTheme } from "@material-ui/core/styles";

const customTheme = createMuiTheme({
  typography: {
    fontFamily: '"Inter", sans-serif;',
  },
});

export default customTheme;
